<template lang="html">
  <section class="form-box" :class="{incompleted: !specialization}">
    <div class="container">

      <div class="row">
        <h2 class="urlap-title">{{ label }} / Dokumentum típusa</h2>
      </div>
      <div class="row">
        <div class="specialization-icons">
            <button
              v-for="(data,key) in fieldOptions"
              :key="key"
              class="select-specialization"
              @click="popup(key)"
              :class="{selected: specKeyIsSelected(key)}"
              type="button"
              :disabled="files.length > 0"
            >
            <img
              :src="'/wp-content/themes/lebe-childtheme/assets/images/ico/specialization/'+key+'.png'"
            />
            <span class="text">
              {{data['label']}}
            </span>
          </button>

          <button
            class="select-specialization"
            @click="setSpecialization('mas_szakterulet')"
            :class="{selected: specKeyIsSelected('mas_szakterulet')}"
            type="button"
            :disabled="files.length > 0"
          >
            <img
              src="/wp-content/themes/lebe-childtheme/assets/images/ico/specialization/mas.png"
            />
            <span class="text">
              Más szakterület
            </span>
          </button>
        </div>
      </div>

      <div  v-if="specKeyIsSelected('mas_szakterulet')">
        <div class="row form-label">
          <h6>Más szakterület megadása:</h6>
        </div>
        <div class="row">
          <div class="form-box-item form-group in" :class="{invalid: customSpec.length < 1}">
            <input v-model="customSpec" class="form-control custom" type="text" />
          </div>
        </div>
      </div>

      <div class="row" v-if="docType != ''">
        <div class="col">
          <div class="panel panel-default doctype">
            <div class="panel-body">
              Kiválasztott dokumentum típusa: <b>{{docTypeLabel}}</b>
            </div>
          </div>
        </div>
      </div>

    </div>
    <SpecializationPopup
      v-if="showPopup"
      :options="subOptions"
      :show.sync="showPopup"
      :docType.sync="docType"
      :specialization="specValue"
      :documentsSample="documentsSample"
    />
  </section>
</template>
<script>
import {fieldMixin} from '../../mixin/field'
import SpecializationPopup from '../Popup/SpecializationPopup'

export default {
  mixins: [
    fieldMixin
  ],
  props: [
    'specialization',
    'documentType',
    'files',
    'documentsSample'
  ],
  components: {
    SpecializationPopup
  },
  data: function(){
    return {
      showPopup: false,
      subOptions: {},
      selectedSpecialization: '',
      customSpec$: ''
    }
  },
  computed: {
    //specializáció lokális értéke
    specValue: {
      set(val) {
        this.$emit(`update:specialization`,val)
      },
      get() {
        return this.specialization
      }
    },
    customSpec: {
      get() {
        return this.customSpec$
      },
      set(val) {
        this.customSpec$ = val
        this.$emit(`update:specialization`,val)
      }
    },
    docTypeLabel(){
      let label = ''
      if(this.docType != '') {
        //ha előkonfigolt akkor létezik címkéje, egyébként visszaadja az eredetit értéket
        label = (typeof this.subOptions[this.docType] != "undefined") ? this.subOptions[this.docType].label : this.docType
      }
      return label
    },
    docType: {
      set(val) {
        this.$emit('update:documentType',val)
      },
      get() {
        return this.documentType
      }
    }
  },
  methods: {
    //specializáció kiválasztása
    popup(key) {
      this.setSpecialization(key)
      //set key if opt null
      let subOpt = this.getSupOpt(key)
      if(!subOpt || subOpt == null) {
        //set specialization
        this.specValue = key
      } else if( key === 'ceges_okirat' ) { // céges okiratnál nem kell felugró ablak
        this.specValue = key;
      }
      //sub opciók beállítása
      else {
        this.subOptions = subOpt
        this.showPopup = true
      }
    },
    specKeyIsSelected(key) {
      return this.selectedSpecialization == key
    },
    getSupOpt(key) {
      let subOpt = null
      if(typeof this.fieldOptions[key]['options'] != 'undefined') {
        subOpt = this.fieldOptions[key]['options']
      }
      return subOpt
    },
    setSpecialization(key){
      //watch changes
      if(this.selectedSpecialization != key) {
        //dump sub options (docType)
        this.docType = ''
        this.selectedSpecialization = key
        this.specValue = key
      }
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/sass/_variables.scss';
.form-box .form-control.custom{
  line-height: 35px;
  height: 35px;
}
.row.form-label h6{
  margin-bottom: 3px;
  margin-top: 10px;
}
.specialization-icons{
  margin-top: 2em;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .select-specialization{
    display: flex;
    align-items: center;
    width: 230px;
    height: auto;
    line-height: normal;
    margin: 3px;
    border: 1px solid $default-box-border-color;
    background-color: $default-box-bg-color;
    color: $default-box-text-color;
    padding: 10px 15px;
    &.selected{
      background-color: $selected-box-bg-color;
      border-color: $selected-box-border-color;
    }
    img{
      float: left;
      width: 38px;
    }
    .text{
      text-align: left;
      padding-left: 10px;
      display: block;
      text-transform: none;
    }
  }
}
.panel.doctype{
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  max-width: 705px;
}
.forditas-wrapper .specialization-icons{
  button:disabled, button[disabled]{
    background: initial;
    opacity: 1;
  }
}
</style>
